"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVariableToken = exports.VariableConfig = void 0;
var react_1 = __importDefault(require("react"));
var server_1 = __importDefault(require("react-dom/server"));
var SubstitutionTokenFactory_1 = __importDefault(require("@CommonFrontend/Tokens/SubstitutionTokenFactory"));
var Variable_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Variable/Variable");
var VariableWidget = function (_a) {
    var _b, _c, _d;
    var token = _a.token, attributes = _a.attributes;
    return (react_1.default.createElement(Variable_1.Variable, { label: token.label, isBold: (_b = token.isBold) !== null && _b !== void 0 ? _b : false, isItalic: (_c = token.isItalic) !== null && _c !== void 0 ? _c : false, isStrikethrough: (_d = token.isStrikethrough) !== null && _d !== void 0 ? _d : false, attributes: attributes }));
};
var VariableConfig = {
    type: "variable",
    tokenType: {},
    publicRenderHtmlString: function (_a) {
        var _b, _c, _d;
        var token = _a.token, attributes = _a.attributes;
        return server_1.default.renderToString(react_1.default.createElement(Variable_1.Variable, {
            label: token.label,
            isBold: (_b = token.isBold) !== null && _b !== void 0 ? _b : false,
            isItalic: (_c = token.isItalic) !== null && _c !== void 0 ? _c : false,
            isStrikethrough: (_d = token.isStrikethrough) !== null && _d !== void 0 ? _d : false,
            attributes: attributes,
        }));
    },
    publicRenderReactNode: VariableWidget,
    traits: {},
};
exports.VariableConfig = VariableConfig;
var createVariableToken = function (token) { return ({
    type: "inline",
    subType: "variable",
    isBold: false,
    isItalic: false,
    isStrikethrough: false,
    providerType: token.providerType,
    label: token.name.trim(),
    name: token.apiName.trim(),
    substitutionToken: SubstitutionTokenFactory_1.default.fromLegacyApiToken(token),
}); };
exports.createVariableToken = createVariableToken;
